import { useGameStore } from "../stores/gameStore.js";
import { emit, GameEvents } from "./events.js";

export function isStunned(creature) {
  const stun = creature.statusEffects.find((e) => e.type === "stun");
  if (stun && stun.stacks > 0) {
    stun.stacks--;
    if (stun.stacks <= 0) {
      creature.statusEffects = creature.statusEffects.filter(
        (e) => e.type !== "stun"
      );
    }
    return true;
  }
  return false;
}

export function tickCreature(creature, onAttack) {
  if (creature.isReloading) {
    creature.timer++;
    if (creature.timer >= creature.weapon.reloadSpeed) {
      creature.timer = 0;
      creature.isReloading = false;
      creature.currentAmmo = creature.weapon.magazineSize;
    }
  } else {
    creature.timer++;
    if (creature.timer >= creature.weapon.attackSpeed) {
      creature.timer = 0;
      if (!isStunned(creature)) {
        onAttack();
        if (creature.weapon.magazineSize > 0) {
          creature.currentAmmo--;
          if (creature.currentAmmo <= 0) {
            creature.isReloading = true;
          }
        }
      }
      return true;
    }
  }
  return false;
}

function tickRespawn(game) {
  if (!game.isRespawning) return false;
  if (game.respawnTimer === 0) {
    emit(GameEvents.RESPAWN_START, { player: game.player });
  }
  game.respawnTimer++;
  if (game.respawnTimer >= game.respawnTime) {
    emit(GameEvents.RESPAWN_END, { player: game.player });
    game.finishRespawn();
  }
  return true;
}

export function tickFight() {
  const game = useGameStore();

  if (tickRespawn(game)) return;

  if (!game.isFighting) return;

  const player = game.player;
  const enemy = game.enemy;

  tickCreature(player, () => {
    emit(GameEvents.CREATURE_ATTACK, { attacker: player, defender: enemy });
  });

  if (!game.isFighting) return;

  tickCreature(enemy, () => {
    emit(GameEvents.CREATURE_ATTACK, { attacker: enemy, defender: player });
  });
}
